module.exports = __webpack_public_path__ + "img/phone-green.48eee813.svg";